// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconNumber6 = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path
      fillRule="evenodd"
      d="M12 4a8 8 0 100 16 8 8 0 000-16M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12"
    />,
    <path d="M15.387 9.566c-.21-1.624-1.344-2.772-3.234-2.772-2.548 0-3.766 2.086-3.766 5.6 0 3.066 1.218 4.802 3.654 4.802 2.058 0 3.486-1.428 3.486-3.416 0-1.974-1.246-3.318-3.136-3.318-1.134 0-1.89.476-2.296.952h-.028c.042-1.68.602-3.15 2.058-3.15.938 0 1.442.588 1.554 1.358zm-3.374 2.296c1.064 0 1.792.812 1.792 1.932 0 1.092-.728 1.89-1.778 1.89-1.092 0-1.806-.77-1.806-1.918 0-1.134.742-1.904 1.792-1.904" />
  );
export default SvgIconNumber6;
